import React, { useEffect, useRef, useState } from "react";
import { Send, User } from "lucide-react";

export default function ChatWindow({

    conversation,

    messages,

    onSend,

    sending

}) {

    const [text, setText] = useState("");

    const bottomRef = useRef(null);

    useEffect(() => {

        bottomRef.current?.scrollIntoView({

            behavior: "smooth"

        });

    }, [messages]);

    const send = () => {

        if (!text.trim()) return;

        onSend(text);

        setText("");

    };

    const handleKeyDown = (e) => {

        if (e.key === "Enter") {

            e.preventDefault();

            send();

        }

    };

    if (!conversation) {

        return (

            <div className="chat-window empty-chat-window">

                <div>

                    <User size={70} />

                    <h2>

                        Select a Conversation

                    </h2>

                </div>

            </div>

        );

    }

    return (

        <div className="chat-window">

            {/* Header */}

            <div className="chat-header">

                <div>

                    <h3>

                        {

                            conversation.name ||

                            conversation.phoneNumber

                        }

                    </h3>

                    <span>

                        {

                            conversation.phoneNumber

                        }

                    </span>

                </div>

            </div>

            {/* Messages */}

            <div className="chat-messages">

                {

                    messages.length === 0 && (

                        <div className="no-message">

                            No Messages

                        </div>

                    )

                }

                {

                    messages.map((msg) => (

                        <div

                            key={msg._id}

                            className={

                                msg.direction === "OUTGOING"

                                    ?

                                    "message outgoing"

                                    :

                                    "message incoming"

                            }

                        >

                            <div className="bubble">

                                {

                                    msg.message

                                }

                            </div>

                            <div className="message-time">

                                {

                                    new Date(

                                        msg.createdAt

                                    ).toLocaleTimeString(

                                        [],

                                        {

                                            hour: "2-digit",

                                            minute: "2-digit"

                                        }

                                    )

                                }

                            </div>

                        </div>

                    ))

                }

                <div ref={bottomRef}></div>

            </div>

            {/* Footer */}

            <div className="chat-footer">

                <input

                    type="text"

                    placeholder="Type a message..."

                    value={text}

                    onChange={(e) =>

                        setText(

                            e.target.value

                        )

                    }

                    onKeyDown={handleKeyDown}

                />

                <button

                    onClick={send}

                    disabled={sending}

                >

                    <Send size={18} />

                </button>

            </div>

        </div>

    );

}
